import {encrypto, decrypto} from '@/utils/storage/crypto';

function createLocalStorage() {
    /** Default cache time is 7 days */
    const DEFAULT_CACHE_TIME = 60 * 60 * 24 * 7;

    function set(key, value, expire = DEFAULT_CACHE_TIME) {
        const storageData = {
            value,
            expire: expire !== null ? new Date().getTime() + expire * 1000 : null,
        };
        const json = encrypto(storageData);
        window.localStorage.setItem(key, json);
    }

    function get(key) {
        const json = window.localStorage.getItem(key);
        if (json) {
            let storageData = null;
            try {
                storageData = decrypto(json);
            } catch {
                // Prevent parsing failure
            }
            if (storageData) {
                const { value, expire } = storageData;
                // Return directly if within the valid period
                if (expire === null || expire >= Date.now()) {
                    return value;
                }
            }
            remove(key);
            return null;
        }
        return null;
    }

    function remove(key) {
        window.localStorage.removeItem(key);
    }
    function clear() {
        window.localStorage.clear();
    }

    return {
        set,
        get,
        remove,
        clear,
    };
}

export const localStg = createLocalStorage();